// extracted by mini-css-extract-plugin
export var founder = "style-module--founder--728d3";
export var founder__imgBlock = "style-module--founder__img-block--783b9";
export var founder__info = "style-module--founder__info--5b35d";
export var founder__infoItem = "style-module--founder__info-item--0f37b";
export var founder__infoTitle = "style-module--founder__info-title--12ab4";
export var founder__name = "style-module--founder__name--b9b4c";
export var founder__nameMobile = "style-module--founder__name-mobile--a6bf4";
export var founder__position = "style-module--founder__position--2a2dc";
export var founder__positionMobile = "style-module--founder__position-mobile--7f890";
export var founder__title = "style-module--founder__title--b7c5f";
export var founder__topBlock = "style-module--founder__top-block--1c1af";
export var founder__wrapper = "style-module--founder__wrapper--2b101";
export var mainTitle = "style-module--main-title--0a098";